import React from "react";
import {
  styled,
  Button,
  Switch,
  FormControlLabel,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { MissingDividendsNotice } from "./MissingDividendsNotice";

const Container = styled("div")`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

const HeaderTab = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const MobileActionsRow = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

type Props = {
  unreceivedDividendsCount: number;
  investmentId: string;
  splitAdjust: boolean;
  onToggleSplitAdjust: () => void;
};

export const DividendsTableHeader = ({
  unreceivedDividendsCount,
  investmentId,
  splitAdjust,
  onToggleSplitAdjust,
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  const renderAddDividendsButton = () => (
    <Button
      variant="primary"
      size="small"
      component={Link}
      to={`/investments/${investmentId}/dividend-wizard/create`}
    >
      {t("investment.dividends.addDividends")}
    </Button>
  );

  const renderSplitAdjustSwitch = () => (
    <FormControlLabel
      control={
        <Switch
          checked={splitAdjust}
          value={splitAdjust}
          onChange={onToggleSplitAdjust}
        />
      }
      label={t("investment.dividends.splitAdjust")}
      sx={{
        margin: theme.spacing(0),
      }}
    />
  );

  if (isMd || unreceivedDividendsCount <= 0) {
    return (
      <Container>
        <MissingDividendsNotice
          count={unreceivedDividendsCount}
          investmentId={investmentId}
        />
        <MobileActionsRow>
          {renderSplitAdjustSwitch()}
          {renderAddDividendsButton()}
        </MobileActionsRow>
      </Container>
    );
  }

  return (
    <Container>
      <HeaderTab>
        <MissingDividendsNotice
          count={unreceivedDividendsCount}
          investmentId={investmentId}
        />
        {renderAddDividendsButton()}
      </HeaderTab>
      {renderSplitAdjustSwitch()}
    </Container>
  );
};
